import type { ReactNode } from 'react';
import { useObservable } from '@/shared/hooks/useObservable';
import { notificationService } from '../services/notification.service';
import { mapService } from '@/features/map/services/map.service';
import { Input } from '@/shared/components/Input';
import { AddressAutocomplete } from '@/shared/components/AddressAutocomplete';

function FieldLabel({ sl, en }: { sl: string; en: string }) {
  return (
    <label className="text-xs">
      <span className="text-slate-300 font-medium">{sl}</span>
      <span className="text-slate-500"> / {en}</span>
    </label>
  );
}

function SectionTitle({ children }: { children: ReactNode }) {
  return <div className="text-[11px] font-bold text-slate-500 uppercase tracking-widest">{children}</div>;
}

export function StepFlight() {
  const data = useObservable(notificationService.formData$, notificationService.formData$.value);

  function update(partial: Parameters<typeof notificationService.updateFormData>[0]) {
    notificationService.updateFormData(partial);
  }

  return (
    <div className="space-y-4">
      <SectionTitle>Podatki o letu / Flight data</SectionTitle>

      <div className="space-y-1">
        <FieldLabel sl="Namen leta" en="Purpose of flight" />
        <Input
          value={data.purpose}
          onChange={e => update({ purpose: e.target.value })}
          placeholder="Inšpekcijski pregled / Inspection"
        />
      </div>

      <div className="space-y-1">
        <FieldLabel sl="Datum leta" en="Flight date" />
        <Input
          type="date"
          value={data.flightDate}
          onChange={e => update({ flightDate: e.target.value })}
        />
      </div>

      <div className="flex gap-2">
        <div className="flex-1 space-y-1">
          <FieldLabel sl="Od" en="From" />
          <Input
            type="time"
            value={data.flightTimeFrom}
            onChange={e => update({ flightTimeFrom: e.target.value })}
          />
        </div>
        <div className="flex-1 space-y-1">
          <FieldLabel sl="Do" en="To" />
          <Input
            type="time"
            value={data.flightTimeTo}
            onChange={e => update({ flightTimeTo: e.target.value })}
          />
        </div>
      </div>

      <div className="space-y-1">
        <FieldLabel sl="Lokacija" en="Location" />
        <AddressAutocomplete
          value={data.location}
          onChange={address => update({ location: address })}
          onPlaceSelect={(lat, lng, address) => {
            update({ location: address });
            mapService.flyTo(lat, lng);
            mapService.setTakeoffPoint({ lat, lng });
          }}
          placeholder="Naslov / Address"
        />
      </div>
    </div>
  );
}
